import { filterDuplicates } from "@cappelendamm/utils/array";
import { AUTHOR_INDEX_NAME, AUTHOR_INDEX_SETTINGS } from "./author-index.js";
export const TOPIC_TREES = [
    "aldersgrupper",
    "kategorier",
    "bokgrupper",
    "etiketter",
    "lreplan",
    "utdanningsniv",
    "komponent cdu",
];
const sortableAttributes = [];
const searchableAttributes = [...TOPIC_TREES];
const displayedAttributes = ["*"];
const filterableAttributes = [
    "shops",
    "universeTag",
    "tags",
    "shops.path",
    ...TOPIC_TREES,
];
export const SHARED_SETTINGS = {
    searchableAttributes,
    sortableAttributes,
    filterableAttributes,
    displayedAttributes,
};
export const ItemsIndex = {
    name: "items",
    settings: {
        searchableAttributes: [
            "objectID",
            "name",
            "itemDetails.subtitle",
            "authors",
            "mention",
            "itemDetails.seriesName",
            "format",
            "illustrators",
            "narrators",
            "priceLists",
            "itemDetails.originalTitle",
            "itemDetails.language",
            "itemDetails.literaryWorkName",
            "publicationDate",
            ...TOPIC_TREES,
        ],
        sortableAttributes: ["publicationDate", "immediacyScore"],
        displayedAttributes: ["*"],
        filterableAttributes: [
            "objectID",
            "productId",
            "name",
            "title",
            "authors",
            "format",
            "isDefaultVariant",
            "itemDetails.language",
            "itemDetails.binding",
            "priceLists",
            "itemDetails.seriesName",
            "itemDetails.literaryWorkName",
            "itemDetails.subscriptionType",
            "canBeSold",
            "statusCode",
            "publicationTimestamp",
            "itemType",
            "literaryWorkName",
            "evaluationCopyType",
            "itemDetails.books.sku",
            "slug",
            "illustrators",
            "narrators",
            "translators",
            {
                attributePatterns: [
                    "shops.*",
                    ...TOPIC_TREES.map((topicTree) => `${topicTree}.*`),
                ],
                features: {
                    facetSearch: true,
                    filter: { equality: true, comparison: false },
                },
            },
        ],
    },
};
export const SubscriptionVariantsIndex = {
    name: "subscription-variants",
    settings: {
        searchableAttributes: ["objectID", "name", "itemDetails.subtitle"],
        sortableAttributes: ["immediacyScore"],
        displayedAttributes: ["*"],
        filterableAttributes: [
            "objectID",
            "productId",
            "itemType",
            "itemDetails.subscriptionType",
            "shops.path",
        ],
    },
};
const AMIDAYS_ADDED_FILTERABLE_ATTRIBUTES = [
    "updatedAtTimestamp",
    "indexedAtTimestamp",
    "isDeleted",
    "itemType",
    "shops.id",
    "shops.name",
];
export const AmidaysProductsIndex = {
    name: "amidays-products",
    settings: {
        displayedAttributes: ["*"],
        filterableAttributes: [
            "objectID",
            "productId",
            "statusCode",
            "publicationDate",
            "publicationTimestamp",
            "format",
            "literaryWorkName",
            "shops.path",
            ...AMIDAYS_ADDED_FILTERABLE_ATTRIBUTES,
        ],
    },
};
export const AmidaysSubscriptionsIndex = {
    name: "amidays-subscriptions",
    settings: {
        displayedAttributes: ["*"],
        filterableAttributes: [
            "objectID",
            "productId",
            "statusCode",
            "itemDetails.subscriptionType",
            "shops.path",
            ...AMIDAYS_ADDED_FILTERABLE_ATTRIBUTES,
        ],
    },
};
export const AuthorsIndex = {
    name: AUTHOR_INDEX_NAME,
    settings: mergeIndexSettings(SHARED_SETTINGS, AUTHOR_INDEX_SETTINGS),
};
// First settings dictate both key order and (for arrays) element order.
// We start from the first settings object, then layer local indexSettings on top,
// appending any new array items while preserving the original first ordering.
export function mergeIndexSettings(a, b) {
    const merged = { ...a };
    for (const [rawKey, rawValue] of Object.entries(b)) {
        const existing = merged[rawKey];
        if (Array.isArray(existing) && Array.isArray(rawValue)) {
            // Preserve remote (existing) order; append new unique items from local settings.
            merged[rawKey] = filterDuplicates([
                ...existing,
                ...rawValue,
            ]);
            continue;
        }
        // For non-arrays or when remote value absent, just overwrite / add.
        merged[rawKey] = rawValue;
    }
    return merged;
}
